import { render, staticRenderFns } from "./OrderRedirectStep.vue?vue&type=template&id=18e48efa"
import script from "./OrderRedirectStep.vue?vue&type=script&lang=js"
export * from "./OrderRedirectStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports